import React, {useState, useEffect, useContext} from "react";
import Box from "@mui/material/Box";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Button from "@mui/material/Button";
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import {create} from "@api/benefits";
import {renderForm, updateInfo} from "@components/Form/renderForm";
import {validation} from "@services/validation";
import {Typography} from "@mui/material";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {TabPanel, a11yProps} from '@components/Tabs';
import {useConfirm} from "material-ui-confirm";

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    main: {
        margin: '5px 0'
    },
    label: {
        marginTop: '10px'
    }
});

export const CreateBenefit = ({handleClose}) => {
        const classes = useStyles();
        const {setLoading} = useContext(LoadingContext);
        const {setErrorMessage} = useContext(MessageContext);
        const confirm = useConfirm();

        const onCallback = async (e) => {
            columns.forEach((column) => {
                if (column.name === e.target.name) {
                    column.value = e.target.value;
                    column.error = '';
                }
            })

            setColumns([...columns]);
        }

        const columnsData = [
            // {
            //     name: 'category',
            //     headerName: 'category',
            //     type: 'string',
            //     value: '',
            //     inputProps: {required: false, pattern: `[a-z0-9]+`, minLength: 1},
            //     onCallback: onCallback,
            // },
            {lang: 'main', name: 'descriptions', headerName: 'descriptions', type: 'array', value: [], onCallback: onCallback},
            {lang: 'main', name: 'discount', headerName: 'discount', type: 'string', value: '', onCallback: onCallback,},
            {
                lang: 'main',
                name: 'name',
                headerName: 'name',
                type: 'string',
                value: '',
                inputProps: {required: true, minLength: 3},
                onCallback: onCallback,
            },
            {lang: 'main', name: 'rules', headerName: 'rules', type: 'array', value: [], onCallback: onCallback},
            {lang: 'main', name: 'stores', headerName: 'stores', type: 'array', value: [], onCallback: onCallback},
            {
                lang: 'main',
                name: 'supplier',
                headerName: 'supplier',
                type: 'string',
                value: '',
                inputProps: {required: true},
                onCallback: onCallback
            },
            {lang: 'main', name: 'title', headerName: 'title', type: 'string', value: '', onCallback: onCallback},
            {
                lang: 'main',
                name: 'type',
                headerName: 'type',
                type: 'enum',
                value: '',
                items: ['COUPON', 'POSTCARD', 'POINTS', 'PRODUCT'],
                inputProps: {required: true},
                onCallback: onCallback
            },
            {lang: 'main', name: 'maxRewardsPerUser', headerName: 'maxRewardsPerUser', inputProps: { min: 0 }, value: '', error: '', type: 'number', onCallback},
            {lang: 'main', name: 'validity', value: new Date(), headerName: 'validity', validity: true, type: 'date', onCallback: onCallback},
            {lang: 'main', name: 'segments', headerName: 'segments', value: [], error: '', type: 'segment', onCallback},
            {lang: 'main', name: 'categoryId', headerName: 'category', value: [], error: '', type: 'category', onCallback},
            {lang: 'main', name: 'isDefault', headerName: 'isDefault', value: false, error: '', type: 'switch', onCallback},

            {lang: 'SL', name: 'nameSL', headerName: 'name', type: 'string', value: '', inputProps: {minLength: 3}, onCallback: onCallback,},
            {lang: 'SL', name: 'titleSL', headerName: 'title', type: 'string', value: '', onCallback: onCallback},
            {lang: 'SL', name: 'descriptionsSL', headerName: 'descriptions', type: 'array', value: [], onCallback: onCallback},
            {lang: 'SL', name: 'discountSL', headerName: 'discount', type: 'string', value: '', onCallback: onCallback,},
            {lang: 'SL', name: 'rulesSL', headerName: 'rules', type: 'array', value: [], onCallback: onCallback},
            {lang: 'SL', name: 'storesSL', headerName: 'stores', type: 'array', value: [], onCallback: onCallback},
            {lang: 'SL', name: 'supplierSL', headerName: 'supplier', type: 'string', value: '', onCallback: onCallback},
        ];
        const [columns, setColumns] = useState(columnsData);
        const [value, setValue] = React.useState(0);

        const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            setErrorMessage(null);
            
            try {
                const data = new FormData(event.target);
                let obj = updateInfo(columns, data);
                await create(obj);

                handleClose();
            } catch (e) {
                validation(e, columns, (columns) => {
                    return setColumns([...columns]);
                })
                setErrorMessage(e);
            }
            setLoading(false);
        }

        const handleTabsChange = (event, newValue) => {
            setValue(newValue);
        };

        useEffect(async () => {
            const isDefault = columns.find(({name}) => name === 'isDefault');
            const maxRewardsPerUser = columns.find(({name}) => name === 'maxRewardsPerUser');

            if(isDefault.name === 'isDefault' && isDefault.value === true){
                if(maxRewardsPerUser.value > 0){
                    try{
                        const isConfirm = await confirm({
                            title: '',
                            description: 'There is a max limit per user for the benefit. Do you want to clear it and make default?'});
                        if(!isConfirm){
                            maxRewardsPerUser.disabled = true;
                            maxRewardsPerUser.value = 0;
                        }
                    }catch (e) {
                        isDefault.value = false
                    }
                    setColumns([...columns]);
                }
            }

            if(isDefault.name === 'isDefault' && isDefault.value === true) {
                maxRewardsPerUser.disabled = false
            }
        }, [columns]);

        return (
            <Box
                className={classes.root}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                component="form"
                flexDirection={"column"}
                onSubmit={handleSubmit}
            >
                <Tabs value={value} onChange={handleTabsChange} aria-label="basic tabs example">
                    <Tab label="Main" {...a11yProps(0)} />
                    <Tab label="Second language" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <Box
                        className={classes.main}
                    >

                        {
                            columns.filter(({lang}) => lang === 'main').map((data, key) => {
                                return renderForm(data, key);
                            })
                        }
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Box
                        className={classes.main}
                    >

                        {
                            columns.filter(({lang}) => lang === 'SL').map((data, key) => {
                                return renderForm(data, key);
                            })
                        }
                    </Box>
                </TabPanel>

                <Button
                    type="submit"
                    variant="contained"
                >
                    Save
                </Button>
                <Box className={classes.label}>
                    <Typography component={'h3'} fontSize={18}>Note. Empty segments benefits are playing on any game request.</Typography>
                </Box>
            </Box>
        );
    }
;